<template>
  <div>
    <div v-if="recording" class="record-panel d-inline-flex bg-light rounded-pill">
      <b-button variant="outline-danger" class="rounded-circle" @click="stopRecord">
        <b-icon icon="x"></b-icon>
      </b-button>
      <b-icon
          v-if="!onPause"
          icon="circle-fill"
          scale="0.5"
          shift-v="-3.5"
          animation="fade"
          variant="danger"
          class="m-1"
      />
      <b-icon
          v-else
          icon="circle-fill"
          scale="0.5"
          shift-v="-3.5"
          variant="secondary"
          class="m-1"
      />
      <div class="record-time d-inline">
        {{ recordedTime }}
      </div>
      <b-button v-if="!onPause" variant="outline-primary" class="rounded-circle mr-2" @click="pauseRecord">
        <b-icon icon="pause"></b-icon>
      </b-button>
      <b-button v-else variant="outline-primary" class="rounded-circle mr-2" @click="unpauseRecord">
        <b-icon icon="play"></b-icon>
      </b-button>
      <b-button variant="outline-success" class="rounded-circle" @click="submitRecord">
        <b-icon icon="check"></b-icon>
      </b-button>
    </div>
    <b-button v-else class="round" variant="primary" @click="startRecord">
      <b-icon icon="mic"></b-icon>
    </b-button>
  </div>
</template>

<script>
import {Time} from "../lib/utils";
import * as MicRecorder from "mic-recorder-to-mp3"

const recorder = new MicRecorder({
  bitRate: 128
});

export default {
  name : "audioRecord",
  props: {
    maxSec: Number,
    pause : Boolean,
  },
  data() {
    return {
      time     : 0,
      timeOutID: 0,
      recording: false,
      onPause  : false,
      audioBlob: [],
      audioUrl : ""
    }
  },
  computed: {
    recordedTime() {
      return Time.formatMMSS(this.time);
    }
  },
  methods : {
    startRecord() {
      recorder.start().then(() => {
        this.recording = true;
        this.clockStart();
      });
    },
    stopRecord() {
      this.clockStop();
      this.recording = false;
      this.time = 0;
      return recorder.stop();
    },
    pauseRecord() {
      this.stopRecord()
          .getMp3()
          .then(
              ([_, blob]) => {
                // this.emitAudio(blob);
                this.audioBlob.push(blob);
              });
      this.onPause = true;
      this.clockStop();
    },
    unpauseRecord() {
      this.startRecord();
      this.onPause = false;
    },
    submitRecord() {
      this.recording = false;
      this.time = 0;
      if (this.onPause) return this.$emit("audio", new Blob(this.audioBlob));
      this
          .stopRecord()
          //.getAudio("mp3")
          .getMp3()
          .then(async ([_, blob]) => {
            this.emitAudio(blob);
          });
    },
    clockStart() {
      this.timeOutID = setTimeout(() => {
        if (this.time >= this.maxSec) return this.submitRecord();
        this.time++
        this.clockStart();
      }, 1000);
    },
    clockStop() {
      clearTimeout(this.timeOutID);
    },
    emitAudio(blob) {
      this.audioBlob.push(blob);
      this.$emit("audio", new Blob(this.audioBlob, {type: blob.type}));
    },
  },
}
</script>

<style scoped>
.round {
  width: 46px;
  height: 46px;
  border-radius: 50% !important;;
}

.record-panel {
  height: 46px;
  padding: 0.5rem 0.75rem;
}

.record-time {
  padding: 0.175rem 0.75rem;
  padding-left: 0;
}

.record-panel .btn {
  font-size: 0.65rem;
  padding: 0.375rem 0.45rem;
}
</style>